import Content from '@layout/Content'
import BeamForm from './BeamForm'
import BeamResult from './BeamResult'
import { BeamProvider } from './context'

function BeamPage () {
  return (
    <BeamProvider>
      <Content
        renderInput={<BeamForm />}
        renderOutput={<BeamResult />}
      />
    </BeamProvider>
  )
}

export default BeamPage
